function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/tableui
 */
import { Plugin } from 'ckeditor5/src/core';
import { addListToDropdown, createDropdown, Model, SplitButtonView } from 'ckeditor5/src/ui';
import { Collection } from 'ckeditor5/src/utils';
import InsertTableView from './ui/inserttableview';
import tableIcon from './../theme/icons/table.svg';
import tableColumnIcon from './../theme/icons/table-column.svg';
import tableRowIcon from './../theme/icons/table-row.svg';
import tableMergeCellIcon from './../theme/icons/table-merge-cell.svg';
/**
 * The table UI plugin. It introduces:
 *
 * * The `'insertTable'` dropdown,
 * * The `'tableColumn'` dropdown,
 * * The `'tableRow'` dropdown,
 * * The `'mergeTableCells'` split button.
 *
 * The `'tableColumn'`, `'tableRow'` and `'mergeTableCells'` dropdowns work best with {@link module:table/tabletoolbar~TableToolbar}.
 *
 * @extends module:core/plugin~Plugin
 */

var TableUI = /*#__PURE__*/function (_Plugin) {
  _inherits(TableUI, _Plugin);

  var _super = _createSuper(TableUI);

  function TableUI() {
    _classCallCheck(this, TableUI);

    return _super.apply(this, arguments);
  }

  _createClass(TableUI, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var _this = this;

      var editor = this.editor;
      var t = this.editor.t;
      var contentLanguageDirection = editor.locale.contentLanguageDirection;
      var isContentLtr = contentLanguageDirection === 'ltr';
      editor.ui.componentFactory.add('insertTable', function (locale) {
        var command = editor.commands.get('insertTable');
        var dropdownView = createDropdown(locale);
        dropdownView.bind('isEnabled').to(command); // Decorate dropdown's button.

        dropdownView.buttonView.set({
          icon: tableIcon,
          label: t('Insert table'),
          tooltip: true
        });
        var insertTableView;
        dropdownView.on('change:isOpen', function () {
          if (insertTableView) {
            return;
          } // Prepare custom view for dropdown's panel.


          insertTableView = new InsertTableView(locale);
          dropdownView.panelView.children.add(insertTableView);
          insertTableView.delegate('execute').to(dropdownView);
          dropdownView.buttonView.on('open', function () {
            // Reset the chooser before showing it to the user.
            insertTableView.rows = 0;
            insertTableView.columns = 0;
          });
          dropdownView.on('execute', function () {
            editor.execute('insertTable', {
              rows: insertTableView.rows,
              columns: insertTableView.columns
            });
            editor.editing.view.focus();
          });
        });
        return dropdownView;
      });
      editor.ui.componentFactory.add('tableColumn', function (locale) {
        var options = [{
          type: 'switchbutton',
          model: {
            commandName: 'setTableColumnHeader',
            label: t('Header column'),
            bindIsOn: true
          }
        }, {
          type: 'separator'
        }, {
          type: 'button',
          model: {
            commandName: isContentLtr ? 'insertTableColumnLeft' : 'insertTableColumnRight',
            label: t('Insert column left')
          }
        }, {
          type: 'button',
          model: {
            commandName: isContentLtr ? 'insertTableColumnRight' : 'insertTableColumnLeft',
            label: t('Insert column right')
          }
        }, {
          type: 'button',
          model: {
            commandName: 'removeTableColumn',
            label: t('Delete column')
          }
        }, {
          type: 'button',
          model: {
            commandName: 'selectTableColumn',
            label: t('Select column')
          }
        }];
        return _this._prepareDropdown(t('Column'), tableColumnIcon, options, locale);
      });
      editor.ui.componentFactory.add('tableRow', function (locale) {
        var options = [{
          type: 'switchbutton',
          model: {
            commandName: 'setTableRowHeader',
            label: t('Header row'),
            bindIsOn: true
          }
        }, {
          type: 'separator'
        }, {
          type: 'button',
          model: {
            commandName: 'insertTableRowAbove',
            label: t('Insert row above')
          }
        }, {
          type: 'button',
          model: {
            commandName: 'insertTableRowBelow',
            label: t('Insert row below')
          }
        }, {
          type: 'button',
          model: {
            commandName: 'removeTableRow',
            label: t('Delete row')
          }
        }, {
          type: 'button',
          model: {
            commandName: 'selectTableRow',
            label: t('Select row')
          }
        }];
        return _this._prepareDropdown(t('Row'), tableRowIcon, options, locale);
      });
      editor.ui.componentFactory.add('mergeTableCells', function (locale) {
        var options = [{
          type: 'button',
          model: {
            commandName: 'mergeTableCellUp',
            label: t('Merge cell up')
          }
        }, {
          type: 'button',
          model: {
            commandName: isContentLtr ? 'mergeTableCellRight' : 'mergeTableCellLeft',
            label: t('Merge cell right')
          }
        }, {
          type: 'button',
          model: {
            commandName: 'mergeTableCellDown',
            label: t('Merge cell down')
          }
        }, {
          type: 'button',
          model: {
            commandName: isContentLtr ? 'mergeTableCellLeft' : 'mergeTableCellRight',
            label: t('Merge cell left')
          }
        }, {
          type: 'separator'
        }, {
          type: 'button',
          model: {
            commandName: 'splitTableCellVertically',
            label: t('Split cell vertically')
          }
        }, {
          type: 'button',
          model: {
            commandName: 'splitTableCellHorizontally',
            label: t('Split cell horizontally')
          }
        }];
        return _this._prepareMergeSplitButtonDropdown(t('Merge cells'), tableMergeCellIcon, options, locale);
      });
    }
    /**
     * Creates a dropdown view from a set of options.
     *
     * @private
     * @param {String} label The dropdown button label.
     * @param {String} icon An icon for the dropdown button.
     * @param {Array.<module:ui/dropdown/utils~ListDropdownItemDefinition>} options The list of options for the dropdown.
     * @param {module:utils/locale~Locale} locale
     * @returns {module:ui/dropdown/dropdownview~DropdownView}
     */

  }, {
    key: "_prepareDropdown",
    value: function _prepareDropdown(label, icon, options, locale) {
      var editor = this.editor;
      var dropdownView = createDropdown(locale);

      var commands = this._fillDropdownWithListOptions(dropdownView, options); // Decorate dropdown's button.


      dropdownView.buttonView.set({
        label: label,
        icon: icon,
        tooltip: true
      }); // Make dropdown button disabled when all options are disabled.

      dropdownView.bind('isEnabled').toMany(commands, 'isEnabled', function () {
        for (var _len = arguments.length, areEnabled = new Array(_len), _key = 0; _key < _len; _key++) {
          areEnabled[_key] = arguments[_key];
        }

        return areEnabled.some(function (isEnabled) {
          return isEnabled;
        });
      });
      this.listenTo(dropdownView, 'execute', function (evt) {
        editor.execute(evt.source.commandName);
        editor.editing.view.focus();
      });
      return dropdownView;
    }
    /**
     * Creates a dropdown view with a {@link module:ui/dropdown/button/splitbuttonview~SplitButtonView} for
     * merge (and split)–related commands.
     *
     * @private
     * @param {String} label The dropdown button label.
     * @param {String} icon An icon for the dropdown button.
     * @param {Array.<module:ui/dropdown/utils~ListDropdownItemDefinition>} options The list of options for the dropdown.
     * @param {module:utils/locale~Locale} locale
     * @returns {module:ui/dropdown/dropdownview~DropdownView}
     */

  }, {
    key: "_prepareMergeSplitButtonDropdown",
    value: function _prepareMergeSplitButtonDropdown(label, icon, options, locale) {
      var editor = this.editor;
      var dropdownView = createDropdown(locale, SplitButtonView);
      var mergeCommandName = 'mergeTableCells'; // Main command.

      var mergeCommand = editor.commands.get(mergeCommandName); // Subcommands in the dropdown.

      var commands = this._fillDropdownWithListOptions(dropdownView, options);

      dropdownView.buttonView.set({
        label: label,
        icon: icon,
        tooltip: true,
        isEnabled: true
      }); // Make dropdown button disabled when all options are disabled together with the main command.

      dropdownView.bind('isEnabled').toMany([mergeCommand].concat(_toConsumableArray(commands)), 'isEnabled', function () {
        for (var _len2 = arguments.length, areEnabled = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          areEnabled[_key2] = arguments[_key2];
        }

        return areEnabled.some(function (isEnabled) {
          return isEnabled;
        });
      }); // Merge selected table cells when the main part of the split button is clicked.

      this.listenTo(dropdownView.buttonView, 'execute', function () {
        editor.execute(mergeCommandName);
        editor.editing.view.focus();
      }); // Execute commands for events coming from the list in the dropdown panel.

      this.listenTo(dropdownView, 'execute', function (evt) {
        editor.execute(evt.source.commandName);
        editor.editing.view.focus();
      });
      return dropdownView;
    }
    /**
     * Injects a {@link module:ui/list/listview~ListView} into the passed dropdown with buttons
     * which execute editor commands as configured in passed options.
     *
     * @private
     * @param {module:ui/dropdown/dropdownview~DropdownView} dropdownView
     * @param {Array.<module:ui/dropdown/utils~ListDropdownItemDefinition>} options The list of options for the dropdown.
     * @returns {Array.<module:core/command~Command>} Commands the list options are interacting with.
     */

  }, {
    key: "_fillDropdownWithListOptions",
    value: function _fillDropdownWithListOptions(dropdownView, options) {
      var editor = this.editor;
      var commands = [];
      var itemDefinitions = new Collection();

      var _iterator = _createForOfIteratorHelper(options),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var option = _step.value;
          addListOption(option, editor, commands, itemDefinitions);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      addListToDropdown(dropdownView, itemDefinitions, editor.ui.componentFactory);
      return commands;
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'TableUI';
    }
  }]);

  return TableUI;
}(Plugin); // Adds an option to a list view.
//
// @param {module:table/tableui~DropdownOption} option A configuration option.
// @param {module:core/editor/editor~Editor} editor
// @param {Array.<module:core/command~Command>} commands The list of commands to update.
// @param {Iterable.<module:ui/dropdown/utils~ListDropdownItemDefinition>} itemDefinitions
// A collection of dropdown items to update with the given option.


export { TableUI as default };

function addListOption(option, editor, commands, itemDefinitions) {
  var model = option.model = new Model(option.model);
  var _option$model = option.model,
      commandName = _option$model.commandName,
      bindIsOn = _option$model.bindIsOn;

  if (option.type === 'button' || option.type === 'switchbutton') {
    var command = editor.commands.get(commandName);
    commands.push(command);
    model.set({
      commandName: commandName
    });
    model.bind('isEnabled').to(command);

    if (bindIsOn) {
      model.bind('isOn').to(command, 'value');
    }
  }

  model.set({
    withText: true
  });
  itemDefinitions.add(option);
}